// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__AJkiJ","rounded":"styles_rounded__vE9vB","icon":"styles_icon__Oxka3"};